var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIPill01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42488 17.9957C5.37141 20.3199 5.59349 23.8692 7.91962 25.9212C10.2486 27.9766 13.7986 27.7498 15.8456 25.4265L20.8876 19.7136L18.9304 14.0886L12.4686 12.2814L7.42488 17.9957Z",
    fill: "#FFD98A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.506 6.5657L12.4638 12.2801L20.8843 19.7125L20.8859 19.7127L25.9281 13.9982C27.9817 11.6724 27.7596 8.12313 25.4351 6.07135C23.1163 4.02491 19.5645 4.2388 17.5075 6.56586L17.506 6.5657Z",
    fill: "#FFAF17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPill01);
export default __webpack_public_path__ + "static/media/i_pill_01.ef40a93572f0eb47d4dadd82d9b2fbe9.svg";
export { ForwardRef as ReactComponent };